import { Typography } from '@mui/material';
import DialogComponent from '../dialog/dialog.component';
import { makeStyles, createStyles } from '@mui/styles';
import i18n from '../../i18n';

/**
 * 图片预览弹窗，与 RBP2 `component/avatar/avatar-dialog` 一致：带标题与关闭钮。
 */
export default function AvatarDialog(props: {
    open: boolean;
    onClose: () => void;
    data: Array<{
        /** 图片地址 */
        imgSrc: string;
        /** 图片名称 */
        imgName: string;
    }>;
    /** 底部自定义区 */
    footer?: JSX.Element;
}) {
    const { open, onClose, data, footer } = props;
    const classes = useStyles();
    return (
        <DialogComponent
            maxWidth='sm'
            open={open}
            onClose={() => onClose()}
            defaultHeaderProps={{
                // 与 RBP2 一致，使用 `google_text_preview_picture`
                title: i18n.t('google_text_preview_picture'),
                onClose: () => {
                    onClose();
                },
            }}
            className={classes.dialog}
            footer={footer}
        >
            {data.map((item, index) => (
                <div className={classes.imgBox} key={index}>
                    <img src={item.imgSrc} alt='' className={classes.img} />
                    <Typography>{item.imgName}</Typography>
                </div>
            ))}
        </DialogComponent>
    );
}

const useStyles = makeStyles(
    createStyles({
        dialog: {
            minHeight: 200,
        },
        img: {
            maxWidth: '100%',
            maxHeight: '100%',
        },
        imgBox: {
            overflow: 'hidden',
            textAlign: 'center',
            margin: '10px 0px',
        },
    }),
);
